import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

type Props = {
    rows?: number;
    columns?: number;
};

// 表の読み込み中プレースホルダ。ヘッダ1行＋データ rows 行を columns 列ぶん並べ、
// 実体の表構造を想起させる。判定式は呼び出し側のまま、loading 中の見た目のみを置き換える。
export const TableSkeleton: React.FC<Props> = ({ rows = 6, columns = 4 }) => (
    <Box sx={{ width: '100%', p: 1 }} aria-busy="true" aria-live="polite">
        <Stack spacing={1}>
            <Stack direction="row" spacing={1}>
                {Array.from({ length: columns }).map((_, c) => (
                    <Skeleton key={c} variant="rounded" height={32} sx={{ flex: 1 }} />
                ))}
            </Stack>
            {Array.from({ length: rows }).map((_, r) => (
                <Stack key={r} direction="row" spacing={1}>
                    {Array.from({ length: columns }).map((_, c) => (
                        <Skeleton key={c} variant="rounded" height={24} sx={{ flex: 1 }} />
                    ))}
                </Stack>
            ))}
        </Stack>
    </Box>
);
